(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this)),
      );
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString(),
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`,
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate',
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-collection-filters"]) return;
  try {
    
  const collectionFiltersSection = document.querySelector('.shopify-section-collection-filters');
  const collectionFiltersContainer =
    collectionFiltersSection.querySelector('.s-collection-filters');

  const showFiltersButton = collectionFiltersContainer.querySelector(
    '[data-action="show-filter-drawer"]',
  );

  const filterDrawer = collectionFiltersContainer.querySelector('.collection-filters-wrapper');
  const filterDrawerOverlay = collectionFiltersContainer.querySelector(
    '.collection-filters-overlay',
  );
  const filterDrawerCloseButton = collectionFiltersContainer.querySelector(
    '.collection-filters-close',
  );

  /* Getting filter data from JSON */
  const filtersMasterData = getfiltersData();

  function getfiltersData() {
    const filtersDataScript = collectionFiltersSection.querySelector('#filtersData');

    return JSON.parse(filtersDataScript.innerHTML);
  }

  /* Event listeners */
  collectionFiltersContainer.addEventListener('click', (event) => {
    const clickEventPath = event.composedPath().slice(0, -2);

    for (const element of clickEventPath) {
      const clickAction = element?.getAttribute('data-action');

      if (clickAction === 'show-filter-drawer') {
        hideFilterOptions();
        showFilterDrawer();
      } else if (element === filterDrawerCloseButton || element === filterDrawerOverlay) {
        hideFilterDrawer();
      } else if (clickAction === 'toggle-filter-options' || clickAction === 'toggle-sort-options') {
        toggleFilterOptions(element);
        break;
      } else if (clickAction === 'toggle-filter-option' || clickAction === 'select-sort-option') {
        toggleFilterOption(element, clickAction);
        break;
      } else if (clickAction === 'clear-filter-options') {
        clearFilterOptions(element);
        break;
      } else if (clickAction === 'apply-filter-options') {
        applyFilterOptions();
        hideFilterOptions();
        hideFilterDrawer();
        break;
      }
    }
  });

  function showFilterDrawer() {
    document.body.setAttribute('data-overlay', '');
    showFiltersButton.setAttribute('data-active', '');
    filterDrawer.setAttribute('data-active', '');
  }

  function hideFilterDrawer() {
    setTimeout(() => {
      document.body.removeAttribute('data-overlay');
    }, 200);
    showFiltersButton.removeAttribute('data-active');
    filterDrawer.removeAttribute('data-active');
  }

  function hideFilterOptions() {
    const openedFilterOptions = collectionFiltersContainer.querySelectorAll(
      '[data-action="toggle-filter-options"][data-active], [data-action="toggle-sort-options"][data-active]',
    );

    openedFilterOptions.forEach((filterOption) => {
      filterOption.removeAttribute('data-active');
    });
  }

  function toggleFilterOptions(element) {
    const openedFilterOptions = collectionFiltersContainer.querySelectorAll(
      '[data-action="toggle-filter-options"][data-active], [data-action="toggle-sort-options"][data-active]',
    );

    openedFilterOptions.forEach((filterOption) => {
      if (filterOption !== element) {
        filterOption.removeAttribute('data-active');
      }
    });

    element.hasAttribute('data-active')
      ? element.removeAttribute('data-active')
      : element.setAttribute('data-active', '');
  }

  function toggleFilterOption(element, action) {
    if (action === 'select-sort-option' && element.hasAttribute('data-active')) {
      return false;
    } else if (action === 'select-sort-option') {
      const activeSortOptions = element
        .closest('.collection-sort-options')
        .querySelectorAll('[data-active]');

      activeSortOptions.forEach((sortOption) => {
        if (sortOption !== element) {
          sortOption.removeAttribute('data-active');
        }
      });
    }

    element.hasAttribute('data-active')
      ? element.removeAttribute('data-active')
      : element.setAttribute('data-active', '');

    if (action === 'toggle-filter-option') {
      updateFilterValueString(element.closest('.collection-filter-container'));

      const filterId = element
        .closest('.collection-filter-container')
        .getAttribute('data-filter-id');

      const filterValues = [];

      const activeFilterOptions = element
        .closest('.collection-filter-options-container')
        .querySelectorAll('[data-active]');

      activeFilterOptions.forEach((filterOption) => {
        const filterData = {};

        filterData.id = filterOption.getAttribute('data-filter-option-id');
        filterData.label = filterOption.getAttribute('data-filter-option-label');

        filterValues.push(filterData);
      });

      updateFilterOptions(filterId, filterValues);
    } else {
      const sortId = element.getAttribute('data-sort-id');

      updateSortOption(sortId);
    }
  }

  function clearFilterOptions(element) {
    const activeFilterOptions = element
      .closest('.collection-filter-options-container')
      .querySelectorAll('[data-active]');

    element.closest('.collection-filter-container').setAttribute('data-active-filters-count', 0);

    activeFilterOptions.forEach((filterOption) => {
      filterOption.removeAttribute('data-active');
    });

    const filterId = element.closest('.collection-filter-container').getAttribute('data-filter-id');

    const filterValues = [];

    updateFilterOptions(filterId, filterValues);
  }

  function applyFilterOptions() {
    const filtersData = filtersMasterData || getfiltersData();

    const queryParametersString = getQueryParametersString(filtersData);

    const baseUrl = window.location.origin + window.location.pathname;
    const newUrl = baseUrl + queryParametersString;

    window.history.pushState({}, '', newUrl);

    window.location.reload();
  }

  /* State modifying functions */
  function updateFilterOptions(filterId, filterValues) {
    const filtersData = filtersMasterData || getfiltersData();

    filtersData.regularFilters.forEach((filterData) => {
      if (filterData.id === filterId) {
        filterData.values = filterValues;
      }
    });
  }

  function updatePriceFilterData(minValue, maxValue) {
    const filtersData = filtersMasterData || getfiltersData();

    filtersData.priceFilter.min.value = minValue;
    filtersData.priceFilter.max.value = maxValue;
  }

  function updateSortOption(sortId) {
    const filtersData = filtersMasterData || getfiltersData();

    filtersData.productSort.current = sortId;
  }

  /* Helper functions */
  function updateFilterValueString(filter) {
    const filterValueStrings = filter.querySelectorAll('.collection-filter-current-options');
    let currentFilterOptionsString = '';

    const activeFilterOptions = filter.querySelectorAll('[data-active]');
    const numberOfActiveFilterOptions = activeFilterOptions.length;

    if (numberOfActiveFilterOptions === 0) {
      const currentOptionTranslation = collectionFiltersContainer.getAttribute(
        'data-no-filters-translation',
      );
      currentFilterOptionsString = currentOptionTranslation;
    } else {
      activeFilterOptions.forEach((filterOption) => {
        const optionLabel = filterOption.querySelector(
          '.collection-filter-option-label',
        ).textContent;
        currentFilterOptionsString.length === 0
          ? (currentFilterOptionsString += optionLabel)
          : (currentFilterOptionsString += `, ${optionLabel}`);
      });
    }

    filterValueStrings.forEach((filterValueString) => {
      filterValueString.textContent = currentFilterOptionsString;
    });
    filter.setAttribute('data-active-filters-count', numberOfActiveFilterOptions);
  }

  function getQueryParametersString(filtersData) {
    let queryParametersString = '';

    filtersData.regularFilters.forEach((filterData) => {
      const filterId = filterData.id;
      const filterValues = filterData.values;

      if (filterValues.length > 0) {
        filterValues.forEach((filterValue) => {
          queryParametersString.length === 0
            ? (queryParametersString += `?${filterId}=${filterValue.id}`)
            : (queryParametersString += `&${filterId}=${filterValue.id}`);
        });
      }
    });

    if (filtersData.priceFilter && filtersData.priceFilter.min.value !== null) {
      queryParametersString.length === 0
        ? (queryParametersString += `?min_price=${filtersData.priceFilter.min.value}`)
        : (queryParametersString += `&min_price=${filtersData.priceFilter.min.value}`);
    }

    if (filtersData.priceFilter && filtersData.priceFilter.max.value !== null) {
      queryParametersString.length === 0
        ? (queryParametersString += `?max_price=${filtersData.priceFilter.max.value}`)
        : (queryParametersString += `&max_price=${filtersData.priceFilter.max.value}`);
    }

    if (filtersData.productSort.current !== filtersData.productSort.default) {
      queryParametersString.length === 0
        ? (queryParametersString += `?sort_by=${filtersData.productSort.current}`)
        : (queryParametersString += `&sort_by=${filtersData.productSort.current}`);
    }

    return queryParametersString.length === 0 ? '?' : queryParametersString;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-header"]) return;
  try {
    
  // Initialisation propriété custom
  window.trophee = {};
  const trophee = window.trophee;

  trophee.lastScrollY = window.scrollY;

  const headerSection = document.querySelector('.shopify-section-header');
  const headerContainer = document.querySelector('.s-header');

  const indexTemplate = document.querySelector('body').classList.contains('template-index');

  initHeaderHandlers();

  function initHeaderHandlers() {
    window.addEventListener('scroll', throttle(headerVisibilityHandler, 300), {
      passive: true,
    });

    window.addEventListener('scroll', headerShadowHandler, {
      passive: true,
    });

    const menuItems = document.querySelectorAll('.menu-item-container[data-dropdown]');
    const overlay = document.querySelector('.menu-item-overlay');

    menuItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        console.log('Mouse entered');
        const dropdown = item.querySelector('.dropdown-container');
        if (dropdown) {
          const height = dropdown.offsetHeight;
          overlay.style.height = height + 'px';
        }
      });

      item.addEventListener('mouseleave', () => {
        overlay.style.height = '0px';
      });
    });

    headerShadowHandler();
    headerIndexHandler();
  }

  // Show/hide header on scroll handler
  function headerVisibilityHandler() {
    const currentScroll = window.scrollY;

    if (indexTemplate && trophee.lastScrollY < currentScroll && currentScroll > 720) {
      headerContainer.setAttribute('data-hide', '');
    } else if (!indexTemplate && trophee.lastScrollY < currentScroll && currentScroll > 480) {
      headerContainer.setAttribute('data-hide', '');
    } else if (trophee.lastScrollY - currentScroll >= 100) {
      headerContainer.removeAttribute('data-hide');
    }

    trophee.lastScrollY = currentScroll;
  }

  // Box shadow scroll handler
  function headerShadowHandler() {
    const currentScroll = window.scrollY;

    if (indexTemplate && currentScroll >= 480) {
      headerContainer.setAttribute('data-shadow', '');
    } else if (!indexTemplate && currentScroll >= 20) {
      headerContainer.setAttribute('data-shadow', '');
    } else {
      headerContainer.removeAttribute('data-shadow');
    }
  }

  function headerIndexHandler() {
    if (!indexTemplate) return false;

    document.querySelectorAll('.s-header [data-dropdown]').forEach((element) => {
      element.addEventListener('mouseenter', (event) => {
        document.querySelector('.s-header').removeAttribute('data-white');
      });
    });

    document.querySelectorAll('.s-header [data-dropdown]').forEach((element) => {
      element.addEventListener('mouseleave', (event) => {
        document.querySelector('.s-header').setAttribute('data-white', '');
      });
    });
  }

  // Gestion de l'ouverture du menu drawer opening handler
  document
    .querySelector('.s-header .hamburger-icon-container')
    .addEventListener('click', (event) => {
      event.preventDefault();

      updateMenuVisibility('show', document.querySelector('.s-menu-drawer'));
    });

  // Gestion de la fermeture du menu drawer opening handler
  document
    .querySelectorAll('.s-menu-drawer ~ .menu-overlay, .s-menu-drawer .close-icon-container')
    .forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();

        updateMenuVisibility('hide', document.querySelector('.s-menu-drawer'));
      });
    });

  // Gestionnaire menus
  function updateMenuVisibility(command, menuElement) {
    const body = document.querySelector('body');
    const screenWidth = window.screen.width;
    const sections = document.querySelectorAll('.shopify-section');
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    switch (command) {
      case 'show':
        body.setAttribute('data-overlay', '');

        if (screenWidth > 800) {
          sections.forEach((section) => {
            if (!section.classList.contains('no-overlay-shift'))
              section.style.paddingRight = `${scrollbarWidth}px`;
          });
        }

        setTimeout(() => {
          menuElement.setAttribute('data-active', '');
        }, 100);

        break;
      case 'hide':
      default:
        menuElement.removeAttribute('data-active');

        setTimeout(() => {
          body.removeAttribute('data-overlay');

          if (screenWidth > 800) {
            sections.forEach((section) => {
              if (!section.classList.contains('no-overlay-shift'))
                section.style.paddingRight = null;
            });
          }
        }, 300);
    }
  }

  /* Throttle function */
  function throttle(callback, delay) {
    let timeoutId;
    return (...args) => {
      if (!timeoutId) {
        timeoutId = setTimeout(() => {
          callback(...args);
          timeoutId = null;
        }, delay);
      }
    };
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-menu-drawer"]) return;
  try {
    
  // Manage opening/closing of submenus
  document.querySelectorAll('.s-menu-drawer [data-dropdown]').forEach((element) => {
    element.addEventListener('click', (event) => {
      event.preventDefault();

      const menuItem = event.currentTarget.closest('.menu-item');
      const opened = menuItem.hasAttribute('data-open');

      opened ? menuItem.removeAttribute('data-open') : menuItem.setAttribute('data-open', '');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
